export enum IframeInitiator {
  edstein = 'edstein',
  finincubator = 'finincubator',
}
